// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {getFunctions} from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDyFfVOjIDja1alI6BKWR1Qvk9b1dWzjcA",
    authDomain: "lt-falcon.firebaseapp.com",
    projectId: "lt-falcon",
    storageBucket: "lt-falcon.firebasestorage.app",
    messagingSenderId: 194622778198,
    appId: "1:194622778198:web:b3eb85b35c7aa2897244f7",
    measurementId: "G-D754V7BT6Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
export { auth, db, functions };